import { collection } from "firebase/firestore";
// Normal list filters can be applied to nested list
// The purpose of this filter is to access the sub-collection of the collection's document
const nestedListFilter = (document, collectionName) => ({
    collectionQuery: (ref) => {
        return collection(ref, document, collectionName);
    }
});
export default nestedListFilter;
